import { Link, NavLink } from 'react-router-dom'
import { Lockup } from '@/components/brand/Brand'
import { BookCallButton } from '@/components/ui/Button'
import { sitePages } from '@/config/pages'

// NavLink marks the current page with aria-current, which the nav styles; no extra class needed.
// No `end`: the pages have no sub-routes, and "/about/" must still count as About.
const noClass = () => undefined

/** The two pages, and the call. Team and Contact live in the footer. */
export const SiteNav = () => {
  return (
    <header className="nav">
      <Link className="nav-brand glass" to={sitePages.home.path} aria-label="United home">
        <Lockup />
      </Link>
      <nav className="nav-links glass" aria-label="Primary">
        <NavLink to={sitePages.howItWorks.path} className={noClass}>
          How it works
        </NavLink>
        <NavLink to={sitePages.about.path} className={noClass}>
          About
        </NavLink>
        <BookCallButton small />
      </nav>
    </header>
  )
}
